// import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { AppBar, Article, Footer, Page } from "../../components";
import { Box } from "@mui/material";
import { brandGradient } from "theme";

export const Journey = () => {
  // Scroll to the top of the page when this component loads
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // TODO Claudia: fix trick

  return (
    <Page>
      {/* <Helmet>
        <title>Journey</title>
      </Helmet> */}
      <AppBar></AppBar>

      <Box
        sx={{
          background: brandGradient,
          color: "common.white",
          textAlign: "center",
        }}
      >
        <Article />
        <Footer />
      </Box>
    </Page>
  );
}
